import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

// Sits beside a disabled catalog create button and says what is still stopping it.
const CatalogSubmitBlockersHint = ({ blockers }) =>
  blockers.length > 0 ? (
    <Typography variant='caption' color='text.secondary' sx={{ mr: 'auto', pl: 1 }}>
      {`Can't submit yet: ${blockers.join(' · ')}`}
    </Typography>
  ) : null;

CatalogSubmitBlockersHint.propTypes = {
  blockers: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default CatalogSubmitBlockersHint;
